<template>
  <div v-show="isShow.isKVShow" class="pageKV">
    <div class="calendarWrapper"  @click.once="onClick">
      <div class="calendar">
        <div class="inner6" :class="{finalPara: !isFinal}">
          <div class="paras">
            <div class="split">
              <p class="pSI p1SI">日历一页页翻过</p>
              <p class="pSI p2SI">新年一步步临近</p>
            </div>
            <div class="split">
              <p class="pSI p3SI">用心感受</p>
              <p class="pSI p4SI">走心陪伴</p>
              <p class="pSI p5SI">让年味触手可及</p>
            </div>
            <div class="split">
              <p class="pSI p6SI">做一副春联</p>
              <p class="pSI p7SI">开启新年吧</p>
            </div>
            <div class="btn pSI p8SI" @click="showNext"></div>
          </div>
        </div>
        <div class="inner5 inner" :class="{slideOut: isInner5}">
          <img src="./5.gif" class="innerImg" alt="">
        </div>
        <div class="inner4 inner" :class="{slideOut: isInner4}">
          <img src="./4.gif" class="innerImg" alt="">
        </div>
        <div class="inner3 inner" :class="{slideOut: isInner3}">
          <img src="./3.gif" class="innerImg" alt="">
        </div>
        <div class="inner2 inner" :class="{slideOut: isInner2}">
          <img src="./2.gif" class="innerImg" alt="">
        </div>
        <div class="inner1 inner" :class="{slideOut: isInner1}">
          <img src="./1.gif" class="innerImg" alt="">
        </div>
      </div>
      <div :class="isOriginClicked ? 'circle' : ''"></div>
      <div class="fpc_corner-box" :class="{pageFlip: isClicked, pageFlipOrigin: isOriginClicked, finalPage: isFinal}" >
        <a class="fpc_page-tip" href="#">
          <div class="fpc_corner-contents"></div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: {
      type: Object
    }
  },
  data() {
    return {
      isFinal: false,
      isClicked: false,
      isOriginClicked: true,
      isOut: false,
      isInner1: false,
      isInner2: false,
      isInner3: false,
      isInner4: false,
      isInner5: false,
      isInner6: false,
      isInner7: false,
      isInner8: false,
    }
  },
  methods: {
    showNext () {
      this.isShow.isKVShow = false
      this.isShow.isPOShow = true
    },
    onClick() {
      this.isClicked = true;
      this.isOriginClicked = false;
      // inner1
      setTimeout(() => {
        this.isInner1 = true;
        this.isClicked = false;
      }, 600);

      // inner2
      setTimeout(() => {
        this.isClicked = true;
      }, 1600);
      setTimeout(() => {
        this.isInner2 = true;
        this.isClicked = false;
      }, 2200);

      // inner3
      setTimeout(() => {
        this.isClicked = true;
      }, 3200);
      setTimeout(() => {
        this.isInner3 = true;
        this.isClicked = false;
      }, 3800);

      // inner4
      setTimeout(() => {
        this.isClicked = true;
      }, 4800);
      setTimeout(() => {
        this.isInner4 = true;
        this.isClicked = false;
      }, 5400);

      // inner5
      setTimeout(() => {
        this.isClicked = true;
      }, 6400);
      setTimeout(() => {
        this.isInner5 = true;
        this.isClicked = false;
        this.isFinal = true;
      }, 7000);
    }
  }
}
</script>

<style lang="less" scoped>
.pageKV {
  height: 100%;
  background-color: #fff;
  .calendarWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .calendar {
    position: relative;
    width: 46.875/2rem /* 750/16 */;
    height: 75.375/2rem /* 1206/16 */;
    .inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
    }
    .innerImg {
      width: 100%;
      height: 100%;
    }
    .inner6 {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 46.875/2rem /* 750/16 */;
      height: 75.375/2rem /* 1206/16 */;
      background-image: url('./bg2.jpg');
      background-size: cover;
      background-repeat: no-repeat;
      .paras {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #cf3229;
        font-size: 1rem /* 16/16 */;
        font-weight: bold;
        letter-spacing: .125rem /* 2/16 */;
        line-height: 2.6;
        .split {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: .625rem /* 10/16 */;
        }
        .btn {
          margin-top: 1.25rem /* 20/16 */;
          margin-bottom: 6.25rem /* 100/16 */;
          width: 12.0625rem /* 193/16 */;
          height: 3.625rem /* 58/16 */;
          background-image: url('./btn-make.png');
          background-size: contain;
          background-repeat: no-repeat;
          z-index: 5;
        }
      }
    }
    .finalPara {
      display: none;
    }
  }
}
  .finalPage {
    display: none;
  }
  .fpc_corner-box {
    /* edit these sizes for the default revealing corner size */
    position: absolute;
    overflow: visible;
    height: 20px;
    width: 20px;
    right: 0;
    bottom: 0;
    transform: rotate(90deg);
    .fpc_page-tip::before {
      border-right: solid 2px #fff;
    }
    .fpc_page-tip::after {
      border-top: solid 2px #fff;
    }

    .fpc_page-tip {
      position: absolute;
      bottom: 0;
      right: 0;
      content: "";
      background: linear-gradient(45deg, #ddd 17%, #dfdfdf 18%, #f5f5f5 30%, #f8f8f8 34%, #eee 39%, rgba(200, 200, 200, 0) 41%);
      display: block;
      width: 100%;
      height: 100%;
      &::before,
      &::after {
        position: absolute;
        display: block;
        width: 50%;
        height: 50%;
        border-top-right-radius: 60%;
        background-color: #fff;
        z-index: 2;
        content: "";
      }
      &::before {
        right: 100%;
        top: 0%;
        background: -webkit-radial-gradient(-180% 200%, circle, rgba(255, 255, 255, 0) 85%, rgba(0, 0, 0, .1) 93%);
      }
      &::after {
        top: 100%;
        right: 0%;
        background: -webkit-radial-gradient(-250% 320%, circle, rgba(255, 255, 255, 0) 85%, rgba(0, 0, 0, .10) 93%);
      }

      .fpc_corner-contents {
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        width: 125%;
        height: 125%;
        overflow: hidden;
        -webkit-mask: -webkit-linear-gradient(45deg, transparent 49%, #000 53%);
        &::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          width: 100%;
          height: 100%;
          content: "";
          background-color: transparent;
          /* Match this background color to #fpc_effect-back */
        }
        &::after {
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          width: 133%;
          height: 133%;
          content: "";
          background: linear-gradient(45deg, rgba(255, 255, 255, 0) 37%, #DDD 62%, rgba(230, 230, 230, 0.1) 64%, rgba(255, 255, 255, 0) 67%), -webkit-radial-gradient(-50% 150%, circle, transparent 74%, rgba(0, 0, 0, 0.2) 74%, transparent 81%);
        }
      }
    }
  }
}

:root {
  --innerRadius: 10em;
}

.circle {
  position: absolute;
  right:1.875rem /* 30/16 */;
  bottom:1.875rem /* 30/16 */;
	display: flex;
	align-items: center;
	justify-content: center;
  width: .125rem /* 2/16 */;
  height: .125rem /* 2/16 */;
  background-color: #f33;
  border-radius: 50%;
};

.circle::before,
.circle::after {
	content: '';
	position: absolute;
	width: .25rem /* 4/16 */;
	height: .25rem /* 4/16 */;
	border: 1px solid #f33;
	border-radius: 50%;
	animation: pulse 2s ease-out infinite;
}

.circle::after {
	animation-delay: 1s;
}

@keyframes pulse {
	from {
		transform: scale(1);
		filter: opacity(0.9);
	}

	to {
		transform: scale(4);
		filter: opacity(0);
	}
}

.pageFlipOrigin {
  animation: pageFlipOrigin 1.2s cubic-bezier(0, 0.35, .5, 1.7) infinite;
  animation-fill-mode: both;
}

.pageFlip {
  animation: pageFlip .6s cubic-bezier(0, 0.35, .5, 1.7);
  animation-fill-mode: backwards;
}

@keyframes pageFlipOrigin {
  from {
    width: 20px;
    height: 20px;
  }
  to {
    width: 60px;
    height: 60px;
  }
}

@keyframes pageFlip {
  from {
    width: 20px;
    height: 20px;
  }
  to {
    width: 100px;
    height: 100px;
  }
}

.slideOut {
  animation: slideOut .2s ease-in;
  animation-fill-mode: both;
}

@keyframes slideOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.pSI {
  font-weight: bold;
  animation: slideIn .6s ease-out;
  animation-fill-mode: both;
}

.p1SI {
  animation-delay: .4s;
}

.p2SI {
  animation-delay: 1.2s;
}

.p3SI {
  animation-delay: 2.2s;
}

.p4SI {
  animation-delay: 3.2s;
}

.p5SI {
  animation-delay: 4.2s;
}

.p6SI {
  animation-delay: 5.2s;
}

.p7SI {
  animation-delay: 6.2s;
}

.p8SI {
  animation-delay: 7.2s;
}

@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5*/
  .calendar {
    transform-origin: center;
    transform: scale(.92);
  }
}

@media only screen and (min-height: 550px) and (max-height: 600px)  { /*iphone6和iphone6 s 兼容底部白条*/
  .calendar {
    transform-origin: center;
    transform: scale(.92);
  }
}

@media only screen and (min-height: 610px) and (max-height: 640px)  { /*iphone6 plus 兼容底部白条*/
  .calendar {
    transform-origin: center;
    transform: scale(.92);
  }
}

</style>
